import { api } from "@/lib/api";

/** Maps the public API contract to the existing restaurant storefront view model. */
export function toPublicRestaurantVendor(profile, menu) {
  const storefrontId = `public:${profile.slug}`;
  const categories = (menu?.categories || []).map(({ id, name, sortOrder }) => ({ id, name, sortOrder }));
  const items = (menu?.categories || []).flatMap((category) =>
    (category.items || []).map((item) => ({
      ...item,
      categoryId: category.id,
      image: item.imageUrl || "",
      available: true,
    })),
  );
  const table = profile.table
    ? { ...profile.table, storefrontId }
    : null;

  return {
    id: storefrontId,
    businessType: "restaurant",
    onboarded: true,
    name: profile.name,
    slug: profile.slug,
    tagline: profile.tagline || "",
    description: profile.description || "",
    logo: profile.logoUrl || "",
    coverImage: profile.coverUrl || "",
    address: profile.address || "",
    phone: profile.phone || "",
    orderMode: profile.orderMode,
    capabilities: profile.capabilities || {},
    categories,
    items,
    storefronts: [{
      id: storefrontId,
      name: profile.name,
      slug: profile.slug,
      taxSettings: profile.taxSettings,
      checkoutFields: profile.checkoutFields,
      serviceRequestTypes: profile.serviceRequestTypes,
    }],
    checkoutFields: profile.checkoutFields,
    taxSettings: profile.taxSettings,
    serviceRequestTypes: profile.serviceRequestTypes,
    tables: table ? [table] : [],
  };
}

export async function loadPublicRestaurantStorefront(slug, { tableId } = {}) {
  const [profile, menu] = await Promise.all([
    api.getPublicStorefront(slug, { tableId }),
    api.getPublicStorefrontMenu(slug, { tableId }),
  ]);
  return toPublicRestaurantVendor(profile, menu);
}

export function toPublicCustomerOrder(order) {
  return {
    ...order,
    code: order.orderNumber,
    createdAt: order.placedAt,
    subtotal: order.subtotalAmount,
    tax: order.taxAmount,
    total: order.totalAmount,
    taxEnabled: order.taxAmount > 0,
    customer: { name: "Guest", phone: "—", address: "—" },
    items: (order.items || []).map((item) => ({ ...item, qty: item.quantity })),
  };
}
